import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { FormControlMixin } from "../../utilities/mixins/form-control.js";
import { watch } from "../../utilities/watch.js";
import { LeafElement } from "../leaf-element.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --leaf-radio-box-shadow-color: var(--leaf-color-border-active-outline);\n  font-family: var(--leaf-typography-label-small-font-family);\n  font-size: var(--leaf-typography-label-small-font-size);\n  font-weight: var(--leaf-typography-label-small-font-weight);\n  line-height: var(--leaf-typography-label-small-line-height);\n  -webkit-text-decoration: var(--leaf-typography-label-small-text-decoration);\n          text-decoration: var(--leaf-typography-label-small-text-decoration);\n  text-transform: var(--leaf-typography-label-small-text-transform);\n  display: block;\n}\n\n:host(:focus),\n:host(:focus-visible),\n:host(:focus-within) {\n  outline: 0;\n}\n:host(:focus) .leaf-c-radio__input,\n:host(:focus-visible) .leaf-c-radio__input,\n:host(:focus-within) .leaf-c-radio__input {\n  box-shadow: 0 0 0 calc(var(--leaf-border-width-button-default) * 1) var(--leaf-color-border-knockout), 0 0 0 calc(var(--leaf-border-width-button-default) * 2) var(--leaf-radio-box-shadow-color);\n}\n\n:host([invalid]:focus) .leaf-c-radio__input,\n:host([invalid]:focus-visible) .leaf-c-radio__input,\n:host([invalid]:focus-within) .leaf-c-radio__input {\n  --leaf-radio-box-shadow-color: var(--leaf-color-border-error);\n}\n\n:host(:disabled),\n:host([disabled]) {\n  pointer-events: none;\n}\n:host(:disabled) .leaf-c-radio__input,\n:host([disabled]) .leaf-c-radio__input {\n  background-color: var(--leaf-color-bg-disabled);\n  border-color: var(--leaf-color-border-disabled);\n}\n:host(:disabled) .leaf-c-radio__checked,\n:host([disabled]) .leaf-c-radio__checked {\n  background-color: var(--leaf-color-content-disabled);\n}\n\n.leaf-c-radio__wrapper {\n  align-items: center;\n  display: flex;\n  gap: var(--leaf-spacing-8);\n}\n\n.leaf-c-radio__input {\n  align-items: center;\n  border: var(--leaf-border-width-default) solid var(--leaf-color-border-strong);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  min-height: var(--leaf-spacing-24);\n  min-width: var(--leaf-spacing-24);\n}\n\n.leaf-c-radio__checked {\n  border-radius: 50%;\n  background-color: var(--leaf-color-content-brand);\n  height: var(--leaf-spacing-12);\n  width: var(--leaf-spacing-12);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafRadio = class _LeafRadio extends FormControlMixin(LeafElement) {
  constructor() {
    super(...arguments);
    this.internals = this.attachInternals();
    this.value = "";
  }
  connectedCallback() {
    super.connectedCallback();
    this.internals.role = "radio";
    this.setFormControlElement(this);
    this.addEventListener("click", this.onClick);
    this.addEventListener("keydown", this.onKeydown);
    if (!this.hasAttribute("tabindex")) {
      this.tabIndex = 0;
    }
  }
  handleStateChange() {
    this.internals.ariaInvalid = this.invalid ? "true" : "false";
    this.internals.ariaChecked = this.checked ? "true" : "false";
    this.internals.ariaDisabled = this.disabled ? "true" : "false";
    if (this.invalid) {
      this.internals.states.add("--invalid");
    } else {
      this.internals.states.delete("--invalid");
    }
    if (this.checked) {
      this.internals.states.add("--checked");
    } else {
      this.internals.states.delete("--checked");
    }
    if (this.disabled) {
      this.internals.states.add("--disabled");
    } else {
      this.internals.states.delete("--disabled");
    }
  }
  render() {
    return html`
      <div class="leaf-c-radio__wrapper">
        <div class="leaf-c-radio__input">${this.checked ? html`<div class="leaf-c-radio__checked"></div>` : ""}</div>
        <span class="leaf-c-radio__label">
          <slot></slot>
        </span>
      </div>
    `;
  }
  onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.checked = true;
  }
  onKeydown(event) {
    if (["Enter", " "].includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      this.click();
    }
  }
};
_LeafRadio.styles = unsafeCSS(styles);
_LeafRadio.formAssociated = true;
let LeafRadio = _LeafRadio;
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafRadio.prototype, "checked", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafRadio.prototype, "disabled", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafRadio.prototype, "invalid", 2);
__decorateClass([
  property()
], LeafRadio.prototype, "value", 2);
__decorateClass([
  watch(["disabled", "invalid", "checked"])
], LeafRadio.prototype, "handleStateChange", 1);
export {
  LeafRadio
};
//# sourceMappingURL=radio.component.js.map
